// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-page {
  display: flex;
  overflow: hidden;
  /* Previously "height: 100%", which relied on the old fixed-100vh
     app shell. The shell now scrolls normally, so the map instead
     sizes itself to exactly one screen's worth of space below the
     always-on header. */
  height: calc(100vh - var(--header-height));
  width: 100%;
  position: relative;
}

.map-page-canvas {
  flex: 1 1;
  min-width: 0;
  position: relative;
}

.map-page-backdrop {
  display: none;
}

/* Dim the map behind the slide-over panel on phones, and let a tap
   on the dimmed area close it. Stops short of the header so it stays
   usable while the panel is open. */
@media (max-width: 768px) {
  .map-page-backdrop {
    display: block;
    position: fixed;
    top: var(--header-height);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1140;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MapPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB;;;wBAGsB;EACtB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;oCAEoC;AACpC;EACE;IACE,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;EACf;AACF","sourcesContent":[".map-page {\n  display: flex;\n  overflow: hidden;\n  /* Previously \"height: 100%\", which relied on the old fixed-100vh\n     app shell. The shell now scrolls normally, so the map instead\n     sizes itself to exactly one screen's worth of space below the\n     always-on header. */\n  height: calc(100vh - var(--header-height));\n  width: 100%;\n  position: relative;\n}\n\n.map-page-canvas {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n}\n\n.map-page-backdrop {\n  display: none;\n}\n\n/* Dim the map behind the slide-over panel on phones, and let a tap\n   on the dimmed area close it. Stops short of the header so it stays\n   usable while the panel is open. */\n@media (max-width: 768px) {\n  .map-page-backdrop {\n    display: block;\n    position: fixed;\n    top: var(--header-height);\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.35);\n    z-index: 1140;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
